// export const DOMAIN = "http://localhost:4000"; // hoặc domain thật
// export const DOMAIN = "https://api.elephant.friend.kakiem.observer"; //4
// export const DOMAIN = "https://api.elephant.bro.kakiem.observer"; //3y
export const DOMAIN = "https://api.elephant.nam.kakiem.observer"; //2
// export const DOMAIN = "https://api.elephant.kakiem.observer"; //1
// export const DOMAIN = "https://api.old.kakiem.observer"; //0


export const DOMAIN_FB = `${DOMAIN}/api/fb/`;